import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Home.module.css';
import axios from 'axios';
import jwtDecode from 'jwt-decode';
import { ReactComponent as MySVG } from './banner.svg';
import Slideshow from './Slideshow';

function Home() {

  const navigate = useNavigate();
  
  const tiers = [
    {
      name: 'premium',
      price: '$5.99',
      features: ['👑Upgrade to our premium tier and celebrate: ', 'Unlimited access to all our app without any ads 🙌', 'Full access to Pronounce. SUPERSTREAM will always provide free access to Pronounce because #translivesmatter and #gayrightsmatter 🏳️‍🌈🥳', 'Priority Access To New Apps 💖'],
    },
    {
      name: 'basic',
      price: 'Free',
      features: ['Experience our basic tier and benefit from: ', 'Full access to Pronounce. SUPERSTREAM will always provide free access to Pronounce because #translivesmatter and #gayrightsmatter 🏳️‍🌈', 'Partial Access To New Apps 🤏'],
    },
  ];

  const handleClickSignUp = () => {
    // Redirect the user to a different page
    navigate('/signup');
  }
  // localStorage.setItem('token', null);
  const handleClickLogin = () => {
    // Redirect the user to a different page
    // if(localStorage.getItem("token") !== 'null' && localStorage.getItem("token") !== null){
    //   //now check if token is valid for name/id
    //   const username = localStorage.getItem("username");
    //   const token = localStorage.getItem("token");
    //   axios.post('/api/checkToken', {
    //     username,
    //     token
    //   })
    //   .then(response =>  {
    //     if (response.status === 200) {
    //       const tokenResponse = response.data;
    //       const user = jwtDecode(tokenResponse).user;
    //       localStorage.setItem('token', tokenResponse.toString());
    //       localStorage.setItem('username', user.username.toString());
    //       localStorage.setItem('_id', user._id.toString());
    //       localStorage.setItem('isSubscribed', user.isSubscribed);
    //       navigate('/dashboard', { state: { user } });
    //     } else if (response.status === 201){
    //       navigate('/login');
    //     }
    //      else {
    //       console.log('Error signing up');
    //     }
    //   }).catch(error => {
    //     console.error(error);
    //   });

    //   // navigate('/dashboard');
    // }else{
      navigate('/login');
    // }
  }
  
  return (
    <div className={`container-fluid`}>
      <div
        className="row align-items-center"
        style={{ padding: '20px', backgroundColor: '#005293', display: 'flex' }}
      >
        <div
          className="col-auto"
          style={{ paddingRight: 0, paddingLeft: 0, flex: '0 0 auto' }}
        >
          <img
            className="img-fluid"
            style={{ width: '150px', height: 'auto' }}
            src="images/logo.png"
            alt="Logo"
          />
        </div>
        <div className="col" style={{ flex: '1' }}></div>
        <div
          className={`col-auto ${styles.buttonWrapper}`}
          style={{
            paddingRight: 0,
            paddingLeft: 0,
            flex: '0 0 auto',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <button
            onClick={handleClickLogin}
            style={{ marginBottom: '25px', marginTop: '25px' }}
          >
            Dashboard
          </button>
        </div>
      </div>




      <div className='row justify-content-center' style={{ paddingBottom: '100px', backgroundColor: '#005293'}}>
        
        
        

        <div className='col-md-5  d-flex align-items-center justify-content-center' style={{padding: '25px'}}>
          <div id="blurb">
              <h1 className={`bigboldyellow`} style={{fontFamily: 'Russo'}}>Supercharge your stream now.</h1>
              <p className={`bignormaltext`} style={{}}>Use our apps to boost engagement and discoverability</p>
                {/* <button style={{margin: '25px'}}>dashboard</button> */}
              <div className='d-flex align-items-center justify-content-center'>
                <button onClick={handleClickSignUp}>Get started!</button>
              </div>  
              
          </div>
        </div>

        <div className='col-md-5  d-flex align-items-center justify-content-center' style={{padding: '25px'}}>
          <img className={`images img-fluid object-fit-scale`} src="images/poster.png"></img>
        </div>
    </div>


    <div className='row justify-content-center' style={{paddingTop: '50px', paddingBottom: '50px', backgroundColor: '#193551'}}>
    <h1 className={`bigboldwhite`}><span className={`bigboldyellow`}>superstream</span> supports all platforms/software:</h1>
      <div className='col-md-1'></div>

        <div className='col-md-3 d-flex align-items-center justify-content-center'>
        <div>
            <h1 className={`bigboldwhite`}>streaming<br></br>platforms</h1>
            <ul style={{color: 'white'}}>
            <li>Twitch</li>
            <li>TikTok</li>
            <li>YouTube</li>
            <li>Facebook Gaming</li>
            <li>Kick</li>
            <li>...and more!</li>
            </ul>
        </div>
        </div>        
        <div className='col-md-4 d-flex align-items-center'>
            <img className={`${styles.images} img-fluid object-fit-scale`} src="images/venndiagram.png"></img>
        </div>
        <div className='col-md-3 d-flex align-items-center justify-content-center'>
        <div>
            <h1 className={`bigboldwhite`}>streaming<br></br>software</h1>
            <ul style={{color: 'white'}}>
            <li>OBS</li>
            <li>Streamlabs Desktop</li>
            <li>XSplit</li>
            <li>Twitch Studio</li>
            <li>Lightstream</li>
            <li>...and more!</li>
            </ul>
        </div>

        </div>
    <div className='col-md-1'></div>
    </div>

    <div className='row justify-content-center' style={{paddingTop: '50px', paddingBottom: '50px', backgroundColor: '#005293'}}>
        <div className='col-md-1'>

        </div>
        <div className='col-md-10  d-flex align-items-center' style={{padding: '25px', justifyContent: 'center'}}>
        <div id="blurb">
        <h1 style={{fontFamily: 'Roboto'}}><span className={`bigboldwhite`}>we have supported</span></h1>
        <h1 style={{fontFamily: 'Roboto'}}><span className={`bigboldyellow`}>60k+ content creators</span></h1>
        <h1 style={{fontFamily: 'Roboto'}}><span className={`bigboldwhite`}>for over</span></h1>
        <h1 style={{fontFamily: 'Roboto'}}><span className={`bigboldyellow`}>5 years</span></h1>
        <h1 style={{fontFamily: 'Roboto'}}><span className={`bigboldwhite`}>with our apps</span></h1>

        </div>
        </div>
        <div className='col-md-1'>

        </div>
    </div>

    <div className='row justify-content-center' style={{paddingTop: '50px', paddingBottom: '50px', backgroundColor: '#193551'}}>
      <div className='col-md-12'>
          <div className='row'>
            <div className='col-md-2'></div>
            <div className='col-md-8'>
              <h1  className={`bigboldwhite`}>Keep viewers entertained with: <span className={`bigboldyellow`}>Showcase for TikTok</span></h1>
            </div>
            <div className='col-md-2'></div>
          </div>
          
          


          <div className='row' style={{padding: '30px'}}>
            <div className='col-md-1'></div>
            <div className='col-md-5 d-flex flex-column justify-content-center'>
              <div className='row'>
                <h3 className={`normalText`}>📣Why you <span style={{fontWeight: 'bold'}}>need</span> SHOWCASE</h3>
              </div>

              <div className='row'>
                <div className='col-md-12'>
                  <ul className={`normalText`} style={{margin: '0px', padding: '0px'}}>
                  <li>Increase the time viewers spend in your stream.</li>
                  <li>Promote your TikTok account naturally.</li>
                  <li>Connect on a personal and fun level with viewers. 📷📣🖼🎞✨</li>
                </ul>
                </div>
              </div>

              <div className='row'>
                <div className='col-md-12 d-flex justify-content-center'>
                  <button style={{margin: '10px'}} onClick={handleClickSignUp}>Start using Showcase!</button>
                </div>
              </div>

            </div>
            <Slideshow images={[{src: "images/poster.png", alt: "Poster"}, {src: "images/SC3.jpg", alt: "Poster"},{src: "images/sc1.jpg", alt: "Poster"}]} />
            <div className='col-md-1'></div>

          </div>
        </div>
    </div>

    <div className='row justify-content-center' style={{paddingTop: '50px', paddingBottom: '50px', backgroundColor: '#005293'}}>
        <div className='col-md-1'>

        </div>
        <div className='col-md-10  d-flex align-items-center' style={{padding: '25px', justifyContent: 'center'}}>
        <div id="blurb">
        <h1 style={{fontFamily: 'Roboto'}}><span className={`bigboldwhite`}>Unlock complete access for only</span></h1>
        <h1 style={{fontFamily: 'Roboto'}}><span className={`bigboldyellow`}>$5.99</span></h1>
        <h1 style={{fontFamily: 'Roboto'}}><span className={`bigboldwhite`}>per month!</span></h1>

        </div>
        </div>
        <div className='col-md-1'>

        </div>
    </div>

    <div className='row justify-content-center' style={{paddingTop: '50px', paddingBottom: '50px', backgroundColor: '#193551'}}>
      
    <div className='col-md-1'>

        </div>
        <div className='col-md-10'>
        <div>
          <h1 className={`bigboldwhite`}>Subscription tiers</h1>
          <div className='row justify-content-center'>

          {tiers.map((tier, index) => (
            
            <div key={index} className="col-md-6 d-flex justify-content-center display-flex flex-column ">
              <div className='row'>
                <div className='col-md-12 d-flex justify-content-center display-flex flex-column '>
                  <h1 className={`bigboldyellow`}><span>{tier.name}</span></h1>
                </div>
              </div>

              <div className='row'>
                <div className='col-md-12 d-flex justify-content-center'>
                  <h3 className={`normalText`} >{tier.price}</h3>
                </div>
              </div>

              <div className='row'>
                <div className='col-md-12 d-flex justify-content-center'>
                  <ul>

                    {tier.features.map((feature, index) => (
                      <div className={`normalText`} key={index}>
                        {index === 0 ? <h4>{feature}</h4> : <li key={index}>{feature}</li>}
                      </div>
                      
                    ))}
                  </ul>
                </div>
              </div>

            </div>
          ))}
          <div className='d-flex align-items-center justify-content-center'>
            <button style={{margin: '10px'}} onClick={handleClickSignUp}>Sign up!</button></div>

          </div>
        </div>
          </div>
        <div className='col-md-1'>

        </div>
    </div>

    <div className='row justify-content-center' style={{paddingTop: '50px', paddingBottom: '50px', backgroundColor: '#005293'}}>
      <h1 className={`bigboldwhite`}><span className={`bigboldyellow`}>superstream</span> products:</h1>

      <div className='col-md-4 d-flex align-items-center justify-content-center' style={{padding: '15px'}}>
        <div>
            <h1 style={{fontFamily: 'Roboto'}} className={`normalText`}>Showcase</h1>
            <img className={`${styles.logoBanner} img-fluid object-fit-scale`} src="images/poster.webp"></img>
            {/* <ul>
            <li>Twitch</li>
            </ul> */}
        </div>
        </div>        
        <div className='col-md-4 d-flex align-items-center justify-content-center' style={{padding: '15px'}}>
        <div>
            <h1 style={{fontFamily: 'Roboto'}} className={`normalText`}>Pronounce</h1>
            <img className={`${styles.logoBanner} img-fluid object-fit-scale`} src="images/pronounce.webp"></img>

        </div>
        </div>
        <div className='col-md-4 d-flex align-items-center justify-content-center' style={{padding: '15px'}}>
        <div>
            <h1 style={{fontFamily: 'Roboto'}} className={`normalText`}>GoLiveBot</h1>
            <img className={`${styles.logoBanner} img-fluid object-fit-scale`} src="images/golivebot.webp"></img>

        </div>

        </div>
    </div>

    <div className='row justify-content-center' style={{paddingTop: '10px', paddingBottom: '50px', backgroundColor: '#005293'}}>
    <div className='col-md-2'></div>
        <div className='col-md-4 d-flex align-items-center justify-content-center' style={{padding: '15px'}}>
        <div>
            <h1 style={{fontFamily: 'Roboto'}} className={`normalText`}>Stream+Care</h1>
            <img className={`${styles.logoBanner} img-fluid object-fit-scale`} src="images/streamcare.webp"></img>

        </div>
        </div>        
        <div className='col-md-4 d-flex align-items-center justify-content-center' style={{padding: '15px'}}>
        <div>
            <h1 style={{fontFamily: 'Roboto'}} className={`normalText`}>SocialFrame</h1>
            <img className={`${styles.logoBanner} img-fluid object-fit-scale`} src="images/socialframe.webp"></img>

        </div>
        </div>
        <div className='col-md-2'></div>

      </div>

      <div className='row justify-content-center' style={{paddingTop: '50px', paddingBottom: '50px', backgroundColor: '#193551'}}>
        <div className='col-md-1'>

        </div>
        <div className='col-md-10  d-flex align-items-center' style={{padding: '25px', justifyContent: 'center'}}>
        <div id="blurb">
        <h1 className={`bigboldwhite`}><span className={`bigboldyellow`}>supercharge </span> your stream with <span className={`bigboldyellow`}>superstream</span> now!</h1>
        <div className='d-flex align-items-center justify-content-center'>
        <button onClick={handleClickSignUp}>Sign up!</button>
        </div>

        </div>
        </div>
        <div className='col-md-1'>

        </div>
    </div>

      <div className='row justify-content-center' style={{padding: '50px', backgroundColor: '#005293'}}>
        <div className={`col-md-3`} style={{paddingRight: 0, paddingLeft: 0}}>
            <div className={`row justify-content-center`}>
              <div className={`col-md-12 d-flex justify-content-center`}>
                <img className={`img-fluid object-fit-scale`} style={{width: '400px'}} src="images/logo.png"></img>
              </div>
            </div>

            <div className={`row justify-content-center`}>
              <div className={`col-md-12`}>
                <p style={{textAlign: 'center',color: 'white'}}>Supercharging streams since 2020</p>
              </div>
            </div>
        </div>
        <div className={`col-md-3`} style={{paddingRight: 0, paddingLeft: 0}}>
          {/* <div className={`row justify-content-center`}>
            <div className={`col-md-12`}>
              <h4 style={{textAlign: 'center'}}>Contact</h4>
            </div>
          </div>
          <div className={`row justify-content-center`}>
            <div className={`col-md-12`}>
              <p>Reach out to us at:<br></br> support@super-stream.co</p>
            </div>
          </div> */}
        </div>
        <div className={`col-md-3`} style={{paddingRight: 0, paddingLeft: 0}}>
        <div className={`row justify-content-center`}>
            <div className={`col-md-12`}>
              <h4 style={{textAlign: 'center', fontWeight: 'bold', color: 'white'}}>Contact</h4>
            </div>
          </div>
          <div className={`row justify-content-center`}>
            <div className={`col-md-12`}>
              <p style={{color: 'white'}}>Reach out to us at:<br></br> support@super-stream.co</p>
            </div>
          </div>
          {/* <div className={`row justify-content-center`}>
              <div className={`col-md-12`}>
                <h4 style={{textAlign: 'center'}}>Find us</h4>
              </div>
          </div> */}

          <div className={`row justify-content-center`}>
              <div className={`col-md-12 d-flex justify-content-center`}>
                <div className={`row justify-content-center`}>
                  <div className={`col-md-3 d-flex justify-content-center`}>
                    <a href="https://twitter.com/superstreamco" target="_blank"><img style={{width: '50px', padding: '2px'}} src="images/twitterwhite.png"></img></a>
                  </div>

                  <div className={`col-md-3 d-flex justify-content-center`}>
                    <a href="https://instagram.com/superstreamco" target="_blank"><img style={{width: '50px', padding: '2px'}} src="images/instawhite.png"></img></a>
                  </div>

                  <div className={`col-md-3 d-flex justify-content-center`}>
                    <a href="https://www.tiktok.com/@superstreamco" target="_blank"><img style={{width: '50px', padding: '2px'}} src="images/tiktokwhite.png"></img></a>
                  </div>

                  <div className={`col-md-3 d-flex justify-content-center`}>
                    <a href="https://youtube.com/channel/UCdxKHziPMLV5r2D40ABdNeQ" target="_blank"><img style={{width: '50px', padding: '2px'}} src="images/youtubewhite.png"></img></a>
                  </div>
                </div>
                
              </div>
          </div>
        </div>
        <div className={`col-md-3`} style={{paddingRight: 0, paddingLeft: 0}}>
          <div className={`row justify-content-center`}>
              <div className={`col-md-12`}>
                <h4 style={{textAlign: 'center', fontWeight: 'bold', color: 'white'}}>Products</h4>
              </div>
          </div> 

          <div className={`row justify-content-center`}>
              <div className={`col-md-12`}>
                <p style={{color: 'white'}}>SHOWCASE for Tiktok<br></br>
                Pronounce<br></br>
                GoLiveBot<br></br>
                SocialFrame<br></br>
                StreamCare
                </p>
              </div>
          </div> 
        </div>
      </div>

    </div>

  );
}

export default Home;
